import { EventBus } from '@johnlewispartnership/wtr-website-eventbus';

export const TROLLEY_EVENTS_CHANNEL = 'wtr-events.trolley';
export const STARTED_TROLLEY_UPDATE_EVENT = 'started_trolley_update';
export const FINISHED_TROLLEY_UPDATE_EVENT = 'finished_trolley_update';

const TrolleyEventBus = new EventBus(TROLLEY_EVENTS_CHANNEL);

export default TrolleyEventBus;
